export default "__VITE_ASSET__DyL5kMKs__"